import { createSlice } from '@reduxjs/toolkit'
import {
  sendMessage,
  fetchInboxMessages,
  fetchSentMessages,
  fetchDraftMessages,
  saveDraftMessage,
  deleteDraftMessage,
  fetchUnreadCount,
} from '../actions/messageActions.js'

const initialState = {
  inbox: [],
  sent: [],
  drafts: [],
  unreadCount: 0,
  loading: false,
  error: null,
}

const messageSlice = createSlice({
  name: 'message',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      // Send message
      .addCase(sendMessage.pending, state => { state.loading = true })
      .addCase(sendMessage.fulfilled, (state, action) => {
        state.loading = false
        state.sent.unshift(action.payload.data)
      })
      .addCase(sendMessage.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Inbox
      .addCase(fetchInboxMessages.pending, state => { state.loading = true })
      .addCase(fetchInboxMessages.fulfilled, (state, action) => {
        state.loading = false
        state.inbox = action.payload.data || []
      })
      .addCase(fetchInboxMessages.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Sent
      .addCase(fetchSentMessages.pending, state => { state.loading = true })
      .addCase(fetchSentMessages.fulfilled, (state, action) => {
        state.loading = false
        state.sent = action.payload.data || []
      })
      .addCase(fetchSentMessages.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Drafts
      .addCase(fetchDraftMessages.pending, state => { state.loading = true })
      .addCase(fetchDraftMessages.fulfilled, (state, action) => {
        state.loading = false
        state.drafts = action.payload.data || []
      })
      .addCase(fetchDraftMessages.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Save draft
      .addCase(saveDraftMessage.pending, state => { state.loading = true })
      .addCase(saveDraftMessage.fulfilled, (state, action) => {
        state.loading = false
        state.drafts.unshift(action.payload.data)
      })
      .addCase(saveDraftMessage.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Delete draft
      .addCase(deleteDraftMessage.pending, state => { state.loading = true })
      .addCase(deleteDraftMessage.fulfilled, (state, action) => {
        state.loading = false
        state.drafts = state.drafts.filter(d => d._id !== action.meta.arg)
      })
      .addCase(deleteDraftMessage.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Unread count
      .addCase(fetchUnreadCount.fulfilled, (state, action) => {
        state.unreadCount = action.payload.data?.count || 0
      })
  }
})

export default messageSlice.reducer